import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { FCFacilitiesSchema, GeneralForListSchema } from "../../generated";
import { authSelector } from "../../redux/selectors/auth.selector";
import { fetchFcFacilities } from "../../services/api.service";
import "./F001.scss";
import Select from "../../components/Select/CustomSelect";
import { useLoadingIndicator } from "../../hooks/LoadingIndicator.hooks";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import CustomButton, { CB_CLASS } from "../../components/Button/CustomButton";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import Title from "../../components/Title/Title";
import { initialGeneralForList } from "../../models/general.model";
import {
  C001Url,
  F002Url,
  F003Url,
  K001Url,
  getForHistoryPush,
} from "../../helper/url.helper";
import { useAuth } from "../../helper/auth.helper";
import { notifyError } from "../../helper/settings.helper";
import { fcListSelector } from "../../redux/selectors/list.selector";
import { listActions } from "../../redux/actions/list.actions";
import { FC_LIST_TYPE, getFcList, getFcListForRedux, getFcListFromRedux } from "../../helper/list.helper";
import { pushWithModifier } from "../../helper/page.helper";

const F001 = () => {
  const { checkLoggedIn } = useAuth();
  const maxWidth = 800;
  const authState = useSelector(authSelector);
  const history = useHistory();
  const location = useLocation();

  const [fcList, setFcList] = useState<FCFacilitiesSchema[]>([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [fcForSelect, setFcForSelect] = useState<
    GeneralForListSchema[]
  >([]);
  const [isLoading, , startLoading, stopLoading] = useLoadingIndicator();
  const [search, setSearch] = useState<string>("");
  const fcListState = useSelector(fcListSelector);
  const dispatch = useDispatch();
  const moveByClick = (e: React.MouseEvent, routeData: any) => pushWithModifier(e, history, routeData);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      startLoading();
      try {
        const res = await fetchFcFacilities(authState, search);
        if (!cancelled) {
          setFcList(res.data);
        }
      } catch (err) {
        if (!cancelled) {
          checkLoggedIn(err);
          notifyError("データの取得に失敗しました。");
          console.error(err);
        }
      } finally {
        if (!cancelled) {
          stopLoading();
        }
      }
    };
    fetchData();
    return () => {
      cancelled = true;
    }
  }, [authState, checkLoggedIn, search, refreshTrigger, startLoading, stopLoading]);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      startLoading();
      try {
        const res = await fetchFcFacilities(authState, "");
        if (!cancelled) {
          setFcForSelect(getFcList(FC_LIST_TYPE.ADD_INIT, res.data));
          dispatch(listActions.makeFcList(getFcListForRedux(res.data)));
        }
      } catch (err) {
        if (!cancelled) {
          checkLoggedIn(err);
          notifyError("データの取得に失敗しました。");
          console.error(err);
        }
      } finally {
        if (!cancelled) {
          stopLoading();
        }
      }
    };
    if (fcForSelect.length == 0) {
      if (fcListState.select_list.length == 0) {
        fetchData();
      } else {
        setFcForSelect(getFcListFromRedux(FC_LIST_TYPE.ADD_INIT, fcListState.select_list));
      }
    }
    return () => {
      cancelled = true;
    }
  }, [authState, dispatch, checkLoggedIn, fcForSelect.length, fcListState.select_list, refreshTrigger, startLoading, stopLoading]);


  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <Title title="FC施設一覧" />
      <div className="plate">
        <div className="on_same_row justify" style={{ maxWidth: maxWidth }}>
          <div className="item">
            <Select
              value={fcForSelect.filter((x) => x.label == search)[0] || null}
              options={fcForSelect}
              className="F001_fc_select"
              onChange={(e: any) => {
                setSearch(e.value == 0 ? "" : fcForSelect.filter((x) => x.value == e.value)[0].label);
              }}
              placeholder="施設"
            />
          </div>
          <CustomButton
            label="＋施設を追加"
            class={[CB_CLASS.RED]}
            onClick={(e: React.MouseEvent) => moveByClick(e, getForHistoryPush(F002Url, [0]))}
          />
        </div>
      </div>
      <PaginationTable
        limit={10}
        max_width={maxWidth}
        headers={["施設名", "", "", ""]}
        list={fcList.map((x, i) => (
          <tr key={i} onClick={(e: React.MouseEvent) => moveByClick(e, getForHistoryPush(F002Url, [x.id]))}>
            <td className="item" style={{ textAlign: "left" }}>
              {x.facility_name}
            </td>
            <td className="item">
              <CustomButton
                label="カレンダー"
                class={[CB_CLASS.BLUE]}
                onClick={(e: React.MouseEvent) => moveByClick(e, getForHistoryPush(K001Url, [x.id, undefined, 1]))}
              />
            </td>
            <td className="item">
              <CustomButton
                label="スタッフ一覧"
                class={[CB_CLASS.BLUE]}
                onClick={(e: React.MouseEvent) => moveByClick(e, getForHistoryPush(F003Url, [x.id]))}
              />
            </td>
            <td className="item">
              <CustomButton
                label="保護者一覧"
                class={[CB_CLASS.BLUE]}
                onClick={(e: React.MouseEvent) => moveByClick(e, getForHistoryPush(C001Url, [x.id]))}
              />
            </td>
          </tr>
        ))}
      />
    </>
  );
};

export default F001;
